import { ReportGeneratorDashboardPanel } from "@/features/report/dashboard/ReportGeneratorDashboardPanel"

export function ReportGeneratorPage() {
    return (
        <ReportGeneratorDashboardPanel />
    )
}